import { render, staticRenderFns } from "./workflowRequestBtn.vue?vue&type=template&id=6c70ee7a&"
import script from "./workflowRequestBtn.vue?vue&type=script&lang=js&"
export * from "./workflowRequestBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports